

type ITokenType = 'user' | 'caremap-viewer';
export class AppPrincipal {
    constructor(){
        throw new Error('should not use ctor, see AppContainer');
    }

    tokenType: ITokenType;

    userId: string;

    email: string;
    isAdmin: boolean;
};

// encapsulate the logic
// NOTE: this is ANONYMOUS care map viewer, not a Viewer Supporter (community) who is an actual user
export const isAnonymousViewer = (principal: AppPrincipal): boolean => {
    return principal.tokenType === 'caremap-viewer';
};
